<template>
  <div id="pcAbout" class="swiper-container about-swiper">
    <div class="swiper-wrapper">
      <div class="swiper-slide page page1">
        <Title>{{$t('message.strid12')}}</Title>
        <video class="video" controls="controls" autoplay="autoplay" loop="loop" muted>
          <source src="" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <img src="@/assets/images/pc/ah1.png" class="h1 dh" alt="">
        <img src="@/assets/images/pc/ah2.png" class="h2 dh" alt="">
      </div>
      <div class="swiper-slide page page2">
        <img src="@/assets/images/pc/ah3.png" :class="['h1', dh2 ? 'dh' : '']" alt="">
        <img src="@/assets/images/pc/light.png" :class="['light', dh2 ? 'dh' : '']" alt="">
        <img src="@/assets/images/pc/ah4.png" :class="['h2', dh2 ? 'dh' : '']" alt="">
        <div class="swiper-container pic-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for = "(i, index) in list" :key="index" >
              <img class="pic" v-lazy="i.img" alt="">
            </div>
          </div>
        </div>
        <div id="thumbs">
          <div @click="moveThumb(index)" class="thumb" v-for = "(i, index) in list" :key="index">
            <img v-lazy="i.img"  alt="">
            <div class="active" v-show="thumbActive == index"></div>
          </div>
        </div>
      </div>
      <div class="swiper-slide page page3">
        <Title>{{$t('message.strid13')}}</Title>
        <img src="@/assets/images/pc/ah5.png" :class="['h1', dh3 ? 'dh' : '']" alt="">
        <img src="@/assets/images/pc/ah6.png" :class="['h2', dh3 ? 'dh' : '']" alt="">
        <div class="pic-wrap">
          <div @click="bigImg(i)" v-for = "(i, index) in imgList" :key="index" :class="`pic${index + 1}`" v-lazy:background-image="{src: i}"></div>
        </div>
        <div class="mask" v-if="img" @click="closeMask">
          <div class="img-wrap">
            <img class="close" src="@/assets/images/close.png" alt="">
            <img class="img" :src="img" alt="">
          </div>
        </div>
      </div>
      <div class="swiper-slide bottom">
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "@/components/bottom"
import Title from "@/components/Title"
import { mapState } from "vuex";
export default {
  components: {
    Title,
    Footer
  },
  computed: {
    ...mapState(["_myData"]),
  },
  watch: {
    '_myData': {
      handler (n, o) {
        if (n) {
          const data = n.about_mlbb
          setTimeout(() => {
            const video = document.querySelector('.video')
            video.src = data.global_overview
            video.controls = false;
          }, 300)
          this.list = data.banner[this.$i18n.locale]
          data.gallery.map(i => {
            this.imgList.push(i.img + '&imageslim')
          })
        }
      },
      immediate: true
    }
  },
  activated () {
    const video = document.querySelector('.video')
    video.play()
  },
  data() {
    return {
      mySwiper: null,
      mySwiper2: null,
      dh2: false,
      dh3: false,
      list: [],
      thumbActive: 0,
      imgList: [],
      img: '',
    };
  },
  mounted() {
    const that = this
    this.mySwiper = new Swiper(".about-swiper", {
      direction : 'vertical',
      slidesPerView: 'auto',
      mousewheel: true,
      on: {
        transitionStart () {
          that.closeMask()
          switch (this.activeIndex) {
            case 1:
              that.dh2 = true
              break;
            case 2:
              that.dh3 = true
              break;
          }
        }
      }
    });
    this.mySwiper2 = new Swiper('.pic-swiper', {
      observer:true,
      nested:true,
      on: {
        transitionStart () {
          that.thumbActive = this.activeIndex
        }
      }
    })
    // setTimeout(() => {
    //   const video = document.querySelector('.video')
    //   video.src = 'https://media.w3.org/2010/05/sintel/trailer.mp4'
    //   this.list = [
    //     {
    //       cover: 'https://i.ytimg.com/vi/htVcWokS-uk/mqdefault.jpg'
    //     },
    //     {
    //       cover: 'https://i.ytimg.com/vi/htVcWokS-uk/mqdefault.jpg'
    //     },
    //     {
    //       cover: 'https://i.ytimg.com/vi/htVcWokS-uk/mqdefault.jpg'
    //     },
    //     {
    //       cover: 'https://i.ytimg.com/vi/htVcWokS-uk/mqdefault.jpg'
    //     }
    //   ]
    //   this.imgList = [
    //     "//akmwebstatic.yuanzhanapp.com/web/madmin/image_f22fa3ec8a2c08281c8e292afea494b0?w=811&h=811&c=4d4441&imageslim",
    //     "//akmwebstatic.yuanzhanapp.com/web/madmin/image_f22fa3ec8a2c08281c8e292afea494b0?w=811&h=811&c=4d4441&imageslim",
    //     "//akmwebstatic.yuanzhanapp.com/web/madmin/image_f22fa3ec8a2c08281c8e292afea494b0?w=811&h=811&c=4d4441&imageslim",
    //     "//akmwebstatic.yuanzhanapp.com/web/madmin/image_f22fa3ec8a2c08281c8e292afea494b0?w=811&h=811&c=4d4441&imageslim",
    //     "//akmwebstatic.yuanzhanapp.com/web/madmin/image_f22fa3ec8a2c08281c8e292afea494b0?w=811&h=811&c=4d4441&imageslim",
    //     "//akmwebstatic.yuanzhanapp.com/web/madmin/image_f22fa3ec8a2c08281c8e292afea494b0?w=811&h=811&c=4d4441&imageslim",
    //     "//akmwebstatic.yuanzhanapp.com/web/madmin/image_f22fa3ec8a2c08281c8e292afea494b0?w=811&h=811&c=4d4441&imageslim",
    //     "//akmwebstatic.yuanzhanapp.com/web/madmin/image_f22fa3ec8a2c08281c8e292afea494b0?w=811&h=811&c=4d4441&imageslim",
    //     "//akmwebstatic.yuanzhanapp.com/web/madmin/image_f22fa3ec8a2c08281c8e292afea494b0?w=811&h=811&c=4d4441&imageslim",
    //   ]
    // }, 1000)
  },
  methods: {
    moveThumb (index) {
      this.mySwiper2.slideTo(index)
    },
    bigImg (src) {
      this.img = src
      this.$store.dispatch('setShow', false)
    },
    closeMask () {
      this.img = ''
      this.$store.dispatch('setShow', true)
    },
    jump (url) {
      if (url) {
        window.open(url)
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/style/about.scss";
</style>